import { useState } from "react";
// Chakra imports
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import DefaultAuth from "layouts/auth/Default";
// Assets
// import illustration from "assets/img/auth/auth.avif";
import illustration from "assets/img/auth/auth.avif";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import { useForm } from "react-hook-form";
import type { AuthFormTypes } from "types/auth";
import { useAuth } from "hooks/AuthHook";
import { useMutation } from "react-query";

function SignIn() {
  // Chakra color mode
  const textColor = useColorModeValue("navy.700", "white");
  const textColorSecondary = "gray.400";
  const brandStars = useColorModeValue("brand.500", "brand.400");
  const [show, setShow] = useState<boolean>(false);
  const handleClick = () => setShow(!show);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<AuthFormTypes>();

  const { authLogin } = useAuth();
  const loginMutate = useMutation({
    mutationFn: authLogin,
  });

  const onSubmitLogin = (data: AuthFormTypes) => {
    loginMutate.mutate(data);
  };
  return (
    <form onSubmit={handleSubmit(onSubmitLogin)}>
      <DefaultAuth illustrationBackground={illustration} image={illustration}>
        <Flex
          maxW={{ base: "100%", md: "max-content" }}
          w="100%"
          mx={{ base: "auto", lg: "0px" }}
          me="auto"
          h="100%"
          alignItems="start"
          justifyContent="center"
          mb={{ base: "30px", md: "60px" }}
          px={{ base: "25px", md: "0px" }}
          mt={{ base: "40px", md: "14vh" }}
          flexDirection="column"
        >
          <Box me="auto">
            <Heading color={textColor} fontSize="36px" mb="10px">
              Login
            </Heading>
            <Text
              mb="36px"
              ms="4px"
              color={textColorSecondary}
              fontWeight="400"
              fontSize="md"
            >
              Entre com seus Usuário
            </Text>
          </Box>
          <Flex
            zIndex="2"
            direction="column"
            w={{ base: "100%", md: "420px" }}
            maxW="100%"
            background="transparent"
            borderRadius="15px"
            mx={{ base: "auto", lg: "unset" }}
            me="auto"
            mb={{ base: "20px", md: "auto" }}
          >
            <Text
              mb="12px"
              ms="4px"
              color="red.500"
              fontWeight="400"
              fontSize="md"
              textAlign="center"
            >
              {String(loginMutate.error ?? "")}
            </Text>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Usuário<Text color={brandStars}>*</Text>
              </FormLabel>
              <Input
                variant="auth"
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Usuário"
                mb="24px"
                fontWeight="500"
                borderColor={!!errors.username ? "red.500" : ""}
                isInvalid={!!errors.username}
                size="lg"
                {...register("username", {
                  required: "Preencha o usuário",
                })}
                id="username"
              />
              <FormLabel
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                display="flex"
              >
                Senha<Text color={brandStars}>*</Text>
              </FormLabel>
              <InputGroup size="md">
                <Input
                  fontSize="sm"
                  placeholder="Senha"
                  mb="24px"
                  size="lg"
                  type={show ? "text" : "password"}
                  borderColor={!!errors.password ? "red.500" : ""}
                  variant="auth"
                  isInvalid={!!errors.password}
                  {...register("password", {
                    required: "Preencha a senha",
                  })}
                  id="password"
                />
                <InputRightElement display="flex" alignItems="center" mt="4px">
                  <Icon
                    color={textColorSecondary}
                    _hover={{ cursor: "pointer" }}
                    as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                    onClick={handleClick}
                  />
                </InputRightElement>
              </InputGroup>
              <Button
                type="submit"
                fontSize="sm"
                variant="brand"
                fontWeight="500"
                w="100%"
                h="50"
                mb="24px"
                isLoading={loginMutate.isLoading}
              >
                Login
              </Button>
            </FormControl>
          </Flex>
        </Flex>
      </DefaultAuth>
    </form>
  );
}

export default SignIn;
